import { Popover, PopoverProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { theme as _theme } from "../../../../helpers/theme";

export const StyledPopover = styled((props: PopoverProps) => (
  <Popover {...props}>{props.children}</Popover>
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
}));
